import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react-router';
import { DialogFooter, DialogHeader, DialogTitle } from '../../../../common/components/ui/dialog';
import { ScrollArea } from '../../../../common/components/ui/scroll-area.tsx';
import { captureError } from '../../../../tracking/logger.ts';
import { LoadingButton } from '../../../../common/components/LoadingButton.tsx';
import { useCartErrorNotification } from '../../state-hooks/useCartErrorNotification';
import { toKeyedItems } from '../../../../common/utils/keyedItems';

export function CartDialogFailure() {
  const { t } = useTranslation();
  const { messages, traceId } = useCartErrorNotification();
  const [isLoading, setIsLoading] = useState(false);

  function handleShoppingCartReload() {
    setIsLoading(true);
    window.location.reload();
  }

  useEffect(() => {
    captureError('Cart Dialog Failure: The dialog `Fehler im Warenkorb` is shown to the user!', messages);
    Sentry.logger.error(
      `Cart Dialog Failure: The dialog "Fehler im Warenkorb" is shown to the user! ${messages.join(' - ')}`
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center mb-0'}>{t('Fehler im Warenkorb')}</DialogTitle>
        <div className={'mt-2 text-xs text-muted-foreground'}>
          {new Date().toLocaleString()}
          {traceId && (
            <>
              {' | ID: '}
              <code>{traceId}</code>
            </>
          )}
        </div>
      </DialogHeader>
      <ScrollArea className="overflow-y-auto">
        <div>
          {messages && messages.length > 0 && messages[0].length > 0 ? (
            <ul className="list-none space-y-2">
              {toKeyedItems(messages).map(({ key, item: message }) => (
                <li key={key}>{message}</li>
              ))}
            </ul>
          ) : (
            <span>{t('Im Warenkorb ist ein unerwarteter Fehler aufgetreten')}!</span>
          )}
        </div>
      </ScrollArea>
      <DialogFooter className={'mt-4 flex-col desktop:flex-row gap-4 desktop:gap-1'}>
        <LoadingButton loading={isLoading} onClick={handleShoppingCartReload} data-testid={'cart-reload-button'}>
          {t('Seite neu laden')}!
        </LoadingButton>
      </DialogFooter>
    </>
  );
}
